module.exports = Promise.resolve(module.bundle.root("cqNIf"))